<!-- Login Modal -->
<div class="modal fade" id="loginModal" tabindex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered modal-dialog-scrollable max-w-350-px">
        <div class="modal-content bg-transparent border-0 rounded-0">
            <div class="modal-header bg-transparent p-0">
                <button class="btn btn-primary bg-orange-light text-white rounded-0 px-4 py-2" *ngFor="let role of loginRole"
                    (click)="toggleForm(role.id)" [class.active]="role.selected">{{ role.title }}</button>
            </div>
            <div [class]="'modal-body bg-white' | themeSwitch">
                <div class="p-3 position-relative">
                    <ng-container *ngFor="let role of loginRole">
                        <div *ngIf="role.selected" class=" d-flex flex-column">
                            <img  src="assets/images/svg/user-circle-pink.svg" class="mx-auto img-pink" alt=""  />
                            <img  src="assets/images/svg/user-circle-red.svg" class="mx-auto img-red" alt=""  />
                            <img  src="assets/images/svg/user-circle-green.svg" class="mx-auto img-green" alt=""  />
                            <img  src="assets/images/svg/user-circle-blue.svg" class="mx-auto img-blue" alt=""  />
                            <img  src="assets/images/svg/user-circle-black.svg" class="mx-auto img-black" alt=""  />
                            <h5 class="text-center text-uppercase fw-bold">{{ role.title }} LOGIN</h5>
                            <hr>
                            <form [formGroup]="loginForms[role.id]" (ngSubmit)="submitLoginForm(loginForms[role.id])">
                                <ng-container *ngIf="role.loginBy.length>1">
                                    <div class="text-center link-container">
                                        <a class="px-2" *ngFor="let method of role.loginBy"
                                            (click)="toggleLoginBy(role.id, method.id);false;"
                                            [class.active]="method.selected" href="">{{
                                            method.title
                                            }}</a>
                                    </div>
                                    <hr>
                                </ng-container>
                                <div *ngFor="let method of role.loginBy">
                                    <div class="form-floating form-group mb-4" *ngIf="method.selected">
                                        <input type="text" formControlName="{{ method.id }}" required
                                            class="form-control" [id]="method.id"
                                            [attr.placeholder]="'Enter '+method.title" />
                                        <label [for]="method.id" class="form-label">{{ method.title }}</label>
                                    </div>
                                </div>
                                <div class="form-floating">
                                    <input type="password" class="form-control" id="floatingPassword"
                                        placeholder="Password" togglePassword formControlName="password" />
                                    <label for="floatingPassword" class="form-label">Enter Password</label>
                                </div>
                                <div class="d-flex mb-2">
                                    <a href="#" class="ms-auto text-orange-light fw-bold"
                                        (click)="forgotPasswordModal.show();false">Froget Password?</a>
                                </div>
                                <button type="submit"  class="btn btn-primary bg-orange-light text-white mt-2 btn-lg w-100">Login</button>
                            </form>
                        </div>
                    </ng-container>
                    <button type="button" class="btn btn-flat position-absolute top-0 end-0" data-bs-dismiss="modal"
                        aria-label="Close"><i class="fa fa-x-close"></i></button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Forgot Password Modal -->
<div class="modal fade" id="forgotPasswordModal" tabindex="-1" aria-labelledby="forgotPasswordModalLabel"
    aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered modal-dialog-scrollable max-w-350-px">
        <div class="modal-content bg-transparent border-0 rounded-0">
            <div [class]="'modal-body bg-white' | themeSwitch">
                <div class="p-3 position-relative">
                    <ng-container *ngFor="let role of loginRole">
                        <div *ngIf="role.selected && forgotPasswordForms[role.id]" class=" d-flex flex-column">
                            <img  src="assets/images/svg/user-circle-pink.svg" class="mx-auto img-pink" alt=""  />
                            <img  src="assets/images/svg/user-circle-red.svg" class="mx-auto img-red" alt=""  />
                            <img  src="assets/images/svg/user-circle-green.svg" class="mx-auto img-green" alt=""  />
                            <img  src="assets/images/svg/user-circle-blue.svg" class="mx-auto img-blue" alt=""  />
                            <img  src="assets/images/svg/user-circle-black.svg" class="mx-auto img-black" alt=""  />
                            <h5 class="text-center text-uppercase fw-bold">Forgot Password</h5>
                            <p class="m-0 text-center">Enter {{role.forgetPassword.title}} to recover {{ role.title }}
                                Password</p>
                            <hr>
                            <form [formGroup]="forgotPasswordForms[role.id]" (ngSubmit)="submitforgetPasswordForm()">
                                <div class="form-floating form-group  mb-4">
                                    <input type="text" formControlName="{{ role.forgetPassword.id }}" required
                                        class="form-control" [id]="role.forgetPassword.id"
                                        [attr.placeholder]="'Enter '+role.forgetPassword.title" />
                                    <label class="form-label" [for]="role.forgetPassword.id">{{
                                        role.forgetPassword.title }}</label>
                                </div>
                                <button type="submit" class="btn btn-primary bg-orange-light text-white mt-2 btn-lg w-100">Submit</button>
                            </form>
                        </div>
                    </ng-container>
                    <button type="button" class="btn btn-flat position-absolute top-0 end-0" data-bs-dismiss="modal"
                        aria-label="Close" (click)="loginModal.show()"><i class="fa fa-x-close"></i></button>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- OTP Modal -->
<div class="modal fade register-modal" id="OTPModal" tabindex="-1" aria-labelledby="OTPModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered modal-dialog-scrollable max-w-350-px">
        <div class="modal-content bg-transparent border-0 rounded-0">
            <div [class]="'modal-body bg-white' | themeSwitch">
                <div class="p-3 position-relative">
                    <ng-container *ngFor="let role of loginRole">
                        <div *ngIf="role.selected && OTPForms[role.id]" class=" d-flex flex-column">
                            <img  src="assets/images/svg/user-circle-pink.svg" class="mx-auto img-pink" alt=""  />
                            <img  src="assets/images/svg/user-circle-red.svg" class="mx-auto img-red" alt=""  />
                            <img  src="assets/images/svg/user-circle-green.svg" class="mx-auto img-green" alt=""  />
                            <img  src="assets/images/svg/user-circle-blue.svg" class="mx-auto img-blue" alt=""  />
                            <img  src="assets/images/svg/user-circle-black.svg" class="mx-auto img-black" alt=""  />
                            <h5 class="text-center text-uppercase fw-bold">OTP VERIFICATION</h5>
                            <p class="m-0 text-center">Enter {{role.forgetPassword.title}} OTP to recover {{role.title}}
                                Password</p>
                            <hr>
                            <form [formGroup]="OTPForms[role.id]" (ngSubmit)="submitOTPForm()">
                                <div class="form-floating form-group mb-4">
                                    <input type="text" formControlName="{{ role.forgetPassword.id }}_OTP" required
                                        class="form-control" [id]="role.forgetPassword.id+'_OTP'"
                                        [attr.placeholder]="'Enter '+role.forgetPassword.title" />
                                    <label class="form-label" [for]="role.forgetPassword.id+'_OTP'">{{
                                        role.forgetPassword.title }}
                                        OTP</label>
                                </div>
                                <div class="row align-items-center mb-3 ">
                                    <div class="col-6">
                                        <b class="text-danger">02:00</b>
                                    </div>
                                    <div class="col-6 text-end"><button type="button" class="btn btn-secondary">Resend
                                            OTP</button></div>
                                </div>
                                <button type="submit" class="btn btn-primary bg-orange-light text-white mt-2 btn-lg w-100">Submit</button>
                            </form>
                        </div>
                    </ng-container>
                    <button type="button" class="btn btn-flat position-absolute top-0 end-0" data-bs-dismiss="modal"
                        aria-label="Close" (click)="forgotPasswordModal.show()"><i class="fa fa-x-close"></i> </button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- password Modal -->
<div class="modal fade" id="passwordModal" tabindex="-1" aria-labelledby="passwordModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered modal-dialog-scrollable max-w-350-px">
        <div class="modal-content bg-transparent border-0 rounded-0">
            <div [class]="'modal-body bg-white' | themeSwitch">
                <div class="p-3 position-relative">
                    <ng-container *ngFor="let role of loginRole">
                        <div *ngIf="role.selected && passwordForms[role.id]" class=" d-flex flex-column">
                            <img  src="assets/images/svg/user-circle-pink.svg" class="mx-auto img-pink" alt=""  />
                            <img  src="assets/images/svg/user-circle-red.svg" class="mx-auto img-red" alt=""  />
                            <img  src="assets/images/svg/user-circle-green.svg" class="mx-auto img-green" alt=""  />
                            <img  src="assets/images/svg/user-circle-blue.svg" class="mx-auto img-blue" alt=""  />
                            <img  src="assets/images/svg/user-circle-black.svg" class="mx-auto img-black" alt=""  />
                            <h5 class="text-center text-uppercase fw-bold">Create Password</h5>
                            <p class="m-0 text-center">Enter New & Confirm Password for {{role.title}}</p>
                            <hr>
                            <form [formGroup]="passwordForms[role.id]" (ngSubmit)="submitPasswordForm()">
                                <div class="form-floating form-group mb-4">
                                    <input type="text" formControlName="password_new" required class="form-control"
                                        [id]="'password_new'" [attr.placeholder]="'Enter '+role.title+' New Password'"
                                        togglePassword />
                                    <label class="form-label" [for]="'password_new'">New Password</label>
                                </div>
                                <div class="form-floating form-group mb-4">
                                    <input type="text" formControlName="password_confirm" required class="form-control"
                                        [id]="'password_confirm'"
                                        [attr.placeholder]="'Enter '+role.title+' Confirm Password'" />
                                    <label class="form-label" [for]="'password_confirm'">Confirm Password</label>
                                </div>
                                <button type="submit" class="btn btn-primary bg-orange-light text-white mt-2 btn-lg w-100">Submit</button>
                            </form>
                        </div>
                    </ng-container>
                    <button type="button" class="btn btn-flat position-absolute top-0 end-0" data-bs-dismiss="modal"
                        aria-label="Close" (click)="forgotPasswordModal.show()"><i class="fa fa-x-close"></i></button>
                </div>
            </div>
        </div>
    </div>
</div>
